import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError, notifySuccess} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import dashboard6 from '../locales/dashboard6.json';
import {Label, Select} from '../../../common/components/form';
import {IconLink} from "../../../common/components/link";
import VSelect from "../../../common/components/form/VSelect";
import saveAs from "file-saver";

class DashboardBox6 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			allWorkOrders: [],
			businessUnitsList: [],
			jobStatusesList: [],
			workOrdersList: [],
			userApprovedStatusesList:[],
			clientApprovedStatusesList:[],
			workInstructions: [],
			teamMembers: [],
			searchForm: {
				business_unit_id: '',
				job_status: 'Open',
				work_order_id: '',
				user_approved_status: '',
				client_approved_status: ''
			}
		}
	}

	openModal = (e, src) => {
		if(src) {
			this.setState({ modalOpen: true, modalVideoSrc: src })
		}
	};
	closeModal = () => this.setState({ modalOpen: false });

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard6);
		this.loadDashboard();
	}

	updateSearchFormState = (object) => {
		const { allWorkOrders, searchForm } = this.state;

		const newSearchForm = {
			...this.state.searchForm,
			...object
		};
		this.setState({searchForm: newSearchForm});

		if("business_unit_id" in object || "job_status" in object) {
			let businessUnitId = searchForm.business_unit_id;
			let jobStatus = searchForm.job_status;

			if ("business_unit_id" in object) {
				businessUnitId = object.business_unit_id;
			}

			if ("job_status" in object) {
				jobStatus = object.job_status;
			}

			const filteredWorkOrders = allWorkOrders.filter(item => {
				if(businessUnitId && jobStatus) {
					return item.business_unit_id === businessUnitId && item.job_status === jobStatus;
				} else if(businessUnitId) {
					return item.business_unit_id === businessUnitId;
				} else if(jobStatus) {
					return item.job_status === jobStatus;
				} else {
					return true;
				}
			});
			const workOrdersList = filteredWorkOrders.map(item => ({
				value: item.id,
				label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
			}));

			this.setState({workOrdersList: workOrdersList});
		}

		this.loadDashboardSearchFormSubmit(newSearchForm);
	};

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/6`);

			const businessUnitsList = response.data.business_units.map(item => ({
				value: item.id,
				label: item.code + ' - ' + item.name
			}));

			const jobStatusesList = response.data.job_statuses.map(item => ({
				value: item,
				label: item
			}));

			const allWorkOrders = response.data.work_orders;
			const workOrdersList = response.data.work_orders.filter(item => item.job_status === 'Open').map(item => ({
				value: item.id,
				label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
			}));

			const userApprovedStatusesList = response.data.user_approved_statuses.map(item => ({
				value: item,
				label: item
			}));

			const clientApprovedStatusesList = response.data.client_approved_statuses.map(item => ({
				value: item,
				label: item
			}));

			this.setState({
				isLoading: false,
				allWorkOrders: allWorkOrders,
				businessUnitsList: businessUnitsList,
				jobStatusesList: jobStatusesList,
				workOrdersList: workOrdersList,
				userApprovedStatusesList: userApprovedStatusesList,
				clientApprovedStatusesList: clientApprovedStatusesList
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

	loadDashboardSearchFormSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		if (!values.business_unit_id && !values.work_order_id) {
			this.setState({workInstructions: [], teamMembers: []});
			return;
		}

		this.setState({isLoading: true});
		try {
			const formData = Object.assign({}, values);

			const response = await api.post('/dashboard/6/search', formData);
			notifySuccess(response.message);

			const workInstructions = response.data.work_instructions;
			const teamMembers = response.data.team_members;

			this.setState({isLoading: false, workInstructions: workInstructions, teamMembers: teamMembers});
		} catch (error) {
			this.setState({isLoading: false});
			notifyError(error.message);
		}
	};

	generateExcel = async () => {
		const { searchForm } = this.state;
		const {notifyError} = this.props;
		if(!searchForm.business_unit_id && !searchForm.work_order_id) {
			notifyError('Please select business unit or work order.');
			return;
		}
		try {
			const response = await api.post('/dashboard/6/generate-excel', {
				business_unit_id: searchForm.business_unit_id,
				job_status: searchForm.job_status,
				work_order_id: searchForm.work_order_id,
				user_approved_status: searchForm.user_approved_status,
				client_approved_status: searchForm.client_approved_status
			});
			const filePath = response.data.report_file_path;
			const fileName = response.data.report_file_name;

			const fileData = await api.get(`/${filePath}`, {responseType: 'blob'});
			saveAs(fileData, fileName);
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;
		const {businessUnitsList, jobStatusesList, workOrdersList, userApprovedStatusesList, clientApprovedStatusesList, searchForm, workInstructions, teamMembers} = this.state;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					<div className="box">
						<div className="box-body with-top-padding">
							<div className="row">
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_business_unit_id')}/>
										<VSelect list={businessUnitsList} clearable={true} value={searchForm.business_unit_id} onChange={selected => this.updateSearchFormState({business_unit_id: selected || '', work_order_id: ''})}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_work_order_id')}/>
										<VSelect list={workOrdersList} clearable={true} value={searchForm.work_order_id} onChange={selected => this.updateSearchFormState({work_order_id: selected || ''})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_job_status')}/>
										<Select list={jobStatusesList} value={searchForm.job_status} onChange={selected => this.updateSearchFormState({job_status: selected, work_order_id: ''})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_user_approved_status')}/>
										<Select list={userApprovedStatusesList} clearable={true} value={searchForm.user_approved_status} onChange={selected => this.updateSearchFormState({user_approved_status: selected})} />
									</div>
								</div>
								<div className="col-md-2">
									<div className="form-group">
										<Label text={translate('dashboard_page_client_approved_status')}/>
										<Select list={clientApprovedStatusesList} clearable={true} value={searchForm.client_approved_status} onChange={selected => this.updateSearchFormState({client_approved_status: selected})} />
									</div>
								</div>
								<div className="col-md-2">
									{
										teamMembers.length > 0 && workInstructions.length > 0 && (
											<div className="form-group">
												<button type="button" className="btn btn-primary" style={{marginTop: '25px'}} onClick={e => this.generateExcel()}>
													{translate('dashboard_page_export_excel')}
												</button>
											</div>
										)
									}
								</div>
							</div>
						</div>
					</div>

					{
						(teamMembers.length > 0) && (
							<div className="box">
								<div className="box-body with-top-padding">
									<div className="table-responsive" style={{maxHeight:'60vh'}}>
										<table className="table table-bordered text-center table-header-fixed">
										<thead>
											<tr>
												<th/>
												{
													workInstructions.map((workInstruction, index) => (
														<th key={`dashboard_page_table_work_instruction_th_${index}`} style={{"minWidth": "30px"}}>
															{
																permissionNames && permissionNames.includes('view_work_instruction')
																	? <IconLink type="link" to={`/work-instructions/detail/${workInstruction.id}`} text={workInstruction.code}/>
																	: workInstruction.code
															}
														</th>
													))
												}
											</tr>
										</thead>
										<tbody>
											{
												teamMembers.map((teamMember, index) => (
													<tr key={`dashboard_page_table_team_member_tr_${index}`}>
														<td className="text-left">{teamMember.name}</td>
														<Fragment>
															{
																workInstructions.map((workInstruction, index2) => {
																	const isSigned = workInstruction.training_docs.find(trainingDoc => trainingDoc.user_id === teamMember.id);
																	return (
																		<td key={`dashboard_page_table_work_instruction_td_${index2}`}>
																			{ isSigned && (
																				<i className="fa fa-check-circle-o fa-3x" style={{"color": "#00a65a"}}/>
																			)}
																		</td>
																	)
																})
															}
														</Fragment>
													</tr>
												))
											}
										</tbody>

									</table>
									</div>
								</div>
							</div>
						)
					}
				</section>

			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError,
	notifySuccess
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox6);
